import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        form: '=',
        context: '=',
        canManageCourse: '<',
        trainingForm: '=',
        key: '<',
        trainingTypes: '<',
        hasPlanningGroups: '<',
        ckconfig: '<',
        isDisabled: '<',
        surveyForms: '='
    },
    template: `
        <div class="block07">
            <form-row-wide error="vm.form.errors.courseTrainings[vm.key].formId">
                <span class="row row-wide" ng-class="{ 'has-error': vm.form.errors.courseTrainings[vm.key].formId }">
                    <label class="label w100p mt10">{{ 'training.Form' | translate }} *</label>
                    <div class="items w100p">
                        <select ng-disabled="vm.isDisabled" class="form-control"
                            ng-model="vm.trainingForm.formId"
                            ng-options="form.id as form.activeI18n.name for form in vm.surveyForms" required>
                        </select>
                        <form-row-wide-error></form-row-wide-error>
                        <p class="desc warn" ng-if="!vm.hasAccessToSurveyForm(vm.trainingForm.formId)">
                            {{ 'courses.Saved value is not displayed. You do not have access to the attached form' | translate }}
                        </p>
                    </div>
                </span>
                <div class="alert alert-warn has-icon" ng-if="vm.form.warnings.courseTrainings[vm.key].formId">
                    <img class="alert-icon" alt="Needs attention" src="assets/css/icon_warn.svg">
                    {{ vm.form.warnings.courseTrainings[vm.key].formId }}
                </div>
            </form-row-wide>
            <form-row-wide error="vm.form.errors.courseTrainings[vm.key].feedbackTitle">
                <span class="row row-wide" ng-class="{ 'has-error': vm.form.errors.courseTrainings[vm.key].feedbackTitle }">
                    <label class="label w100p mt10">{{ 'courses.Feedback title' | translate }} *</label>
                    <div class="items w100p">
                        <input ng-disabled="!vm.canManageCourse"
                            type="text" ng-model="vm.trainingForm.courseTrainingI18ns[vm.defaultLanguage].feedbackTitle" class="form-control">
                        <form-row-wide-error></form-row-wide-error>
                    </div>
                </span>
                <div class="alert alert-warn has-icon" ng-if="vm.form.warnings.courseTrainings[vm.key].feedbackTitle">
                    <img class="alert-icon" alt="Needs attention" src="assets/css/icon_warn.svg">
                    {{ vm.form.warnings.courseTrainings[vm.key].feedbackTitle }}
                </div>
            </form-row-wide>
            <form-row-wide error="vm.form.errors.courseTrainings[vm.key].feedbackIntroduction">
                <span class="row row-wide" ng-class="{ 'has-error': vm.form.errors.courseTrainings[vm.key].feedbackIntroduction }">
                    <label class="label w100p mt10">{{ 'courses.Feedback introduction' | translate }}</label>
                    <div class="items w100p">
                        <ng-ckeditor
                            ng-model="vm.trainingForm.courseTrainingI18ns[vm.defaultLanguage].feedbackIntroduction"
                            class="mt10"
                            ng-config="vm.ckconfig">
                        </ng-ckeditor>
                        <form-row-wide-error></form-row-wide-error>
                    </div>
                </span>
            </form-row-wide>
        </div>
    `
})

export default class {
    constructor (lodash, TokenService, CourseVersionService, CourseVersionTrainingFormService,
                 CourseVersionTrainingFormLearndashService, CourseVersionTrainingFormFileService,
                 COURSE_TRAINING_TYPE_ENUM, COURSE_TRAINING_PASSING_TYPE_ENUM, $translate) {
        this.lodash = lodash;
        this.TokenService = TokenService;
        this.CourseVersionService = CourseVersionService;
        this.CourseVersionTrainingFormService = CourseVersionTrainingFormService;
        this.CourseVersionTrainingFormLearndashService = CourseVersionTrainingFormLearndashService;
        this.CourseVersionTrainingFormFileService = CourseVersionTrainingFormFileService;
        this.COURSE_TRAINING_TYPE_ENUM = COURSE_TRAINING_TYPE_ENUM;
        this.COURSE_TRAINING_PASSING_TYPE_ENUM = COURSE_TRAINING_PASSING_TYPE_ENUM;
        this.defaultLanguage = TokenService.getCompanyLanguage();
        this.$translate = $translate;
    }

    $onInit () {
        this.tooltipTexts = {
            passingType: this.$translate.instant('courses.Training passing type tooltip'),
            description: this.$translate.instant('courses.Training description tooltip')
        };
    }

    hasAccessToSurveyForm (formId) {
        if (!formId) {
            return true;
        }

        return !!this.lodash.find(this.surveyForms, (form) => parseInt(form.id, 10) === parseInt(formId, 10));
    }
}



// WEBPACK FOOTER //
// ./src/app/components/courses/courses/steps/version/training/feedback/index.js